import {useSelector} from "react-redux";
import _ from "lodash";

export default function () {
    const tags = useSelector(state => state.tag.tags);
    const loading = useSelector(state => state.tag.listTagsLoading);
    const activeTags = _.filter(_.get(tags, 'tags'), ['active', true]) || [];

    return { activeTags, loading };
}